import styled from 'styled-components';

export const StyledFileList = styled.div``;
